import styled from 'styled-components';

export const SelectWrapper = styled.div<{ zIndex?: number }>`
  cursor: pointer;
  width: fit-content;
  ${(props) => props.zIndex && `z-index: ${props.zIndex};`}
`;
